module.exports = __webpack_public_path__ + "static/pic03-54e76949ca84f3841aaf9e3508f96b09.svg";